/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { darken, SxProps, Theme } from '@mui/material';

export const registerContainerSX = ({
	isMobile,
	onGoBack,
	adaptWith,
}: {
	isMobile?: boolean;
	onGoBack?: () => void;
	adaptWith?: boolean;
}): SxProps<Theme> => ({
	py: { md: '40px', xs: '14px' },
	px: adaptWith ? '0px' : isMobile ? '14px' : '44px',
	boxShadow: 'none',
	borderRadius: '4px',
	opacity: 1,
	backgroundColor: isMobile ? '#FBFBFC' : '#ffffff',
	width: onGoBack && !adaptWith ? '660px' : '100%',
});

export const loginContainerSX = ({ isMobile }: { isMobile?: boolean }): SxProps<Theme> => ({
	boxShadow: 'none',
	backgroundColor: 'transparent',
	py: isMobile ? '19px' : '31px',
	px: isMobile ? '14px' : '44px',
});

export const loginLabelSX: SxProps<Theme> = (theme) => ({
	color: '#2C2C2C',
	fontSize: 'var(--font-size-md)',
	[theme.breakpoints.down('sm')]: {
		fontSize: 'var(--font-size-sm)',
	},
});

export const loginIsButtonSX: SxProps<Theme> = {
	width: { md: '65%', xs: '100%' },
	borderRadius: '22px',
	paddingTop: '9px',
	paddingBottom: '9px',
	background: '#F1F1F1 0% 0% no-repeat padding-box',
	color: '#2C2C2C',
	fontSize: 'var(--font-size-body)',
	fontWeight: 'bold',
	'&:hover': {
		background: darken('#F1F1F1', 0.1),
	},
};

export const helperErrorTextSX: SxProps<Theme> = {
	marginLeft: '3px',
	fontSize: 'var(--font-size-caption)',
	fontWeight: 'normal',
	marginTop: '0px',
};
